export default "__VITE_ASSET__1y4NBNn7__"